<mat-card class="p-0 shadow mb-2 donation-section" [ngClass]="disabled ? 'disabled': ''">
  <mat-card-header>
    <mat-card-title>Donate to IEA</mat-card-title>
  </mat-card-header>
  <hr class="p-0 mb-2 mt-0">
  <mat-radio-group [formControl]="form" class="flex-col">
    <mat-radio-button value="after" [disabled]="disabled" [checked]="!donationOrder">Not right now</mat-radio-button>
    <mat-radio-button value="D-05"  [disabled]="disabled" [checked]="donationOrder && donationOrder.purchaseItems[0] && donationOrder.purchaseItems[0].unitAmount === 500">$5</mat-radio-button>
    <mat-radio-button value="D-10"  [disabled]="disabled" [checked]="donationOrder && donationOrder.purchaseItems[0] && donationOrder.purchaseItems[0].unitAmount === 1000">$10</mat-radio-button>
    <mat-radio-button value="D-25"  [disabled]="disabled" [checked]="donationOrder && donationOrder.purchaseItems[0] && donationOrder.purchaseItems[0].unitAmount === 2500">$25</mat-radio-button>
  </mat-radio-group>
</mat-card>